/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Системный сервис юзеров
 */

/**
 * Системный сервис юзеров
 */
export class SystemServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения статуса сервиса.
   * Не требует авторизации
   */
  GetSystemStatus = (req?: GetSystemStatusRequestDto, init?: RequestInit): Promise<GetSystemStatusResponseDto> => {
    return fm.request<GetSystemStatusRequestDto, GetSystemStatusResponseDto>(`${this.host}/user/api/v1/system/status${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос проверки доступности сервиса
 */
export type GetSystemStatusRequestDto = {
}
/**
 * Ответ на запрос проверки доступности сервиса
 */
export type GetSystemStatusResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос проверки доступности сервиса
   */
  "GetSystemStatusRequest": {
    "kind": "class",
    "text": "Запрос проверки доступности сервиса",
  },
  /**
   * Ответ на запрос проверки доступности сервиса
   */
  "GetSystemStatusResponse": {
    "kind": "class",
    "text": "Ответ на запрос проверки доступности сервиса",
  },
}